export type StringActionDelegate = (token: string) => void;
